import { createSlice } from "@reduxjs/toolkit/"


let initialState = {
    showAuthModal : false,
    showAnnonceModal:false
}
const navigationSlice = createSlice({
    name:'navigation',
    initialState,
    reducers:{
        setShowAuthModal:(state,{payload})=>{
            state.showAuthModal = payload
        },
        setShowAnnonceModal:(state,{payload})=>{
            state.showAnnonceModal = payload
        },
    }
})

export const { setShowAuthModal,setShowAnnonceModal } = navigationSlice.actions
export default navigationSlice.reducer